import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import { ResultsAndDetail } from "slotworks/integration/revolver/schema/spin-record-schema";
import Record from "slotworks/model/gameplay/records/record";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";
import SymbolModel from "slotworks/server/symbols/symbol-model";

class LineResultBuilder implements ResultBuilder {

    public filter(data: any): boolean {
        const resultsAndDetail = data as ResultsAndDetail;

        if (!resultsAndDetail) {
            return false;
        }

        const detail = resultsAndDetail.detail;

        return detail && detail.type && detail.type === "$LINE";
    }

    public build(record: Record, data: any): Result[] {
        const resultsAndDetail = data as ResultsAndDetail;
        const detail = resultsAndDetail.detail;

        const result = new LineResult();
        result.creditsWon = detail.cash;
        result.matches = detail.positions.length;
        result.symbolType = SymbolModel.convertSymbolToSlotworks(detail.symbol);
        result.line = detail.line;
        result.freespinsWon = 0;

        result.positions = RevolverModel.convertPositionsToGridPositions(detail.positions);

        return [result];
    }
}

export default new LineResultBuilder();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/builders/results/line-result-builder.ts